'use strict';
require('./section-handler-widget');
require('./icon-editor-widget');
require('./table-cell-inplace-editor-widget');
require('./color-picker-widget');

const _ = require('underscore'),
	progressSortConfig = require('../models/progress-sort-config'),
	mmWidgets = require('./mm-widgets');

mmWidgets.fn.progressConfigEditorWidget = function (progressModel, colorPickerModel, iconPersisterModel, iconEditorController, resourceDecompressor) {
	return mmWidgets.each(this, function () {
		const element = this.sectionHandlerWidget(),
			table = element.find('[data-mm-role~="progress-configuration-table"]'),
			iconEditorWidget = element.find('[data-mm-role~="progress-icon-editor"]').iconEditorWidget(iconEditorController, resourceDecompressor),
			rowTemplate = element.find('[data-mm-role~="row-template"]').detach().attr('data-mm-role', ''),
			tbody = table.find('tbody'),
			showConfigurationStatus = function (configurationStatus) {
				const item = rowTemplate.clone().appendTo(tbody),
					color = (configurationStatus.style && configurationStatus.style.background) || 'transparent',
					imageWidget = item.find('[data-mm-role~="status-icon"]'),
					colorWidget = item.find('[data-mm-role~="status-color"]'),
					setProgressIcon = function (icon) {
						const imageUrl = icon && icon.url,
							image = (resourceDecompressor && resourceDecompressor(imageUrl)) || imageUrl;
						imageWidget.data('icon', icon);
						if (image) {
							imageWidget.css('background-image', 'url(' + image + ')');
						} else {
							imageWidget.css('background-image', '');
						}
						element.showSection('initial');
						element.find('[data-mm-event-arg]').addClass('hidden');
					};
				item.attr('data-mm-progress-key', configurationStatus.key).attr('data-mm-role', 'progress-status');
				if (configurationStatus.key === '') {
					item.attr('data-mm-progress-empty-key', true);
				}
				item.find('[data-mm-editable]').tableCellInPlaceEditorWidget().removeAttr('data-mm-editable');
				item.find('[data-mm-role~="status-description"]').text(configurationStatus.description);

				colorWidget.css('background', color).val(color).click(() => {
					element.find('[data-mm-role~="selected-status-description"]').text(configurationStatus.description);
					colorPickerModel.pickColor(true).then((pickedColor) => {
						colorWidget.css('background', pickedColor).val(pickedColor);
					}, () => {
						colorWidget.css('background', '').val(false);
					});
				});

				setProgressIcon(configurationStatus.icon);
				imageWidget.click(() => {
					const icon = imageWidget.data('icon');
					iconPersisterModel.editProgressIcon(icon).then((updatedIcon) => {
						setProgressIcon(updatedIcon);
					});
				});

				item.find('[data-mm-role~="status-priority"]').text(configurationStatus.priority);
				item.find('[data-mm-role~="status-delete"]').click(() => {
					item.remove();
				});
				return item;
			},
			showConfigurationStatuses = function (configurationStatuses) {
				tbody.empty();
				_.each(configurationStatuses, showConfigurationStatus);
			},
			initialize = () => {
				const contentStatusUpdater = progressModel.getContentStatusUpdater(),
					statusConfig = contentStatusUpdater && contentStatusUpdater.getStatusConfig(),
					sortedConfig = statusConfig && progressSortConfig(statusConfig);
				element.find('[data-mm-event-arg]').addClass('hidden');
				showConfigurationStatuses(sortedConfig);
				element.showSection('initial');
			};


		element.find('[data-mm-role~="save"]').click(() => {
			const config = {},
				statuses = table.find('[data-mm-role=progress-status]'),
				existing = _.reject(
					_.unique(statuses.domElements.map(x => {
						return parseInt(x.getAttribute('data-mm-progress-key'), 10);
					})),
					(x) => {
						return isNaN(x);
					}
				);
			let autoKey = 1;
			if (existing.length > 0) {
				autoKey = 1 + _.max(existing);
			}
			statuses.domElements.forEach((statusDOM) => {
				const statusElem = mmWidgets(statusDOM),
					statusConfig = {
						description: statusElem.find('[data-mm-role~=status-description]').text()
					},
					backgroundColor = statusElem.find('[data-mm-role=status-color]').val(),
					icon = statusElem.find('[data-mm-role=status-icon]').data('icon'),
					emptyKey = statusElem.attr('data-mm-progress-empty-key');
				let key = statusElem.attr('data-mm-progress-key'),
					priority = parseInt(statusElem.find('[data-mm-role=status-priority]').text());
				if (backgroundColor && backgroundColor !== 'transparent' && backgroundColor !== 'false') {
					statusConfig.style = {background: backgroundColor };
				} else {
					statusConfig.style = {background: false };
				}
				if (icon) {
					statusConfig.icon = icon;
				}
				if (!key) {
					key = emptyKey ? '' : autoKey++;
				}
				if (isNaN(priority)) {
					priority = 0;
				}
				if (priority) {
					statusConfig.priority = priority;
				}
				config[key] = statusConfig;
			});
			progressModel.setStatusConfig(config);

			element.addClass('hidden');
		});
		element.find('[data-mm-role~="progress-color-picker"]').colorPickerWidget(colorPickerModel);
		colorPickerModel.addEventListener('showColors', () => {
			element.showSection('colors');
		});
		colorPickerModel.addEventListener('hideColors', () => {
			element.showSection('initial');
		});
		element.find('[data-mm-role~="no-color"]').click(colorPickerModel.colorPickedDefault);

		iconEditorController.addEventListener('stage', () => {
			element.showSection('icon-editor');
		});
		iconEditorController.addEventListener('complete pickerActive cancel', () => {
			element.showSection('initial');
		});
		element.find('[data-mm-role~="use-icon"]').click(() => {
			const invalidInput = iconEditorWidget.find('input.validation-error'),
				heightField = iconEditorWidget.find('[data-mm-role~=icon-height]'),
				positionField = iconEditorWidget.find('[data-mm-role~=icon-position]'),
				widthField = iconEditorWidget.find('[data-mm-role~=icon-width]');
			if (invalidInput.length) {
				invalidInput.first().focus();
			} else {
				iconEditorController.setDimensions(
					widthField.val(),
					heightField.val()
				);
				iconEditorController.setPosition(positionField.val());
				iconEditorController.save();
			}
		});


		element.find('[data-mm-role=append]').click(() => {
			const newItem = showConfigurationStatus({});
			newItem.find('[data-mm-default-edit]').click();
		});
		element.on('show', initialize);
		progressModel.addEventListener('configChanged', (config) => {
			if (config) {
				initialize();
			} else {
				element.addClass('hidden');
			}
		});
		element.on('hide', () => {
			colorPickerModel.colorPickCancelled();
			showConfigurationStatuses();
		});

	});
};
